import currency from 'currency.js'
import cn from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/pro-light-svg-icons'

const WhiteLabelCreditPackageItem = (props) => {
  const { creditPackage, onClick, disabled } = props
  const { name, cost, credits } = creditPackage

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'block w-full text-left py-5 px-6 hover:bg-gray-50 focus:bg-gray-50 focus:outline-hidden sm:flex sm:items-center sm:space-x-3',
        { 'bg-gray-100': disabled },
      )}
    >
      <p className="font-medium tracking-tight sm:flex-1 sm:text-sm">{name}</p>
      <span className="block flex-[2] sm:text-right">
        <p className="text-gray-600 text-sm">
          {credits} credit{credits > 1 ? 's' : ''} at £
          {currency(cost).divide(credits).divide(100).format()} per file
        </p>
      </span>
      <p className="font-medium text-sm sm:flex-[2] sm:text-right">
        £{currency(cost / 100).format()}{' '}
      </p>
      <span className="block pr-6">
        <FontAwesomeIcon
          className="absolute right-5 top-1/2 -translate-y-1/2 text-gray-400"
          icon={faAngleRight}
          size="lg"
        />
      </span>
    </button>
  )
}

export default WhiteLabelCreditPackageItem
